<template>
  <v-row justify="center">
    <v-col xl="10">
      <v-card>
        <v-card-title>
          <h2>{{ $t("event.participants.list.title") }}</h2>
          <v-col>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="mt-5 ml-5">
                  <v-btn :icon="$vuetify.breakpoint.smAndDown" class="ma-0 pa-2" color="primary" text @click="$refs.uploadParticipants.click()">
                    <v-icon left>mdi-file-upload-outline</v-icon>
                    <span class="hidden-sm-and-down">{{ $t("event.participants.list.upload") }}</span>
                  </v-btn>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-btn :icon="$vuetify.breakpoint.smAndDown" class="ml-5" color="primary" x-small text @click="downloadExample()">
                    <v-icon x-small left>mdi-file-download-outline</v-icon>
                    <span class="hidden-sm-and-down">{{ $t("event.participants.list.example") }}</span>
                  </v-btn>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-btn :icon="$vuetify.breakpoint.smAndDown" color="primary" text @click="downloadParticipants()">
            <v-icon left>mdi-file-download-outline</v-icon>
            <span class="hidden-sm-and-down">{{ $t("event.participants.list.download") }}</span>
          </v-btn>
          <v-card> </v-card>
          <v-spacer></v-spacer>
          <v-text-field
            :label="$t('event.participants.list.search')"
            append-icon="mdi-magnify"
            hide-details
            single-line
            v-model="search"
          ></v-text-field>
        <input v-show="false" @change="uploadParticipants" ref="uploadParticipants" type="file" />
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :no-data-text="$t('event.participants.list.noData')"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:item.date="props">
            {{ props.item.date | datetime }}
          </template>
          <template v-slot:item.duration="props">
            {{ props.item.duration | duration }}
          </template>

          <template v-slot:item.accessToken="props">
            <a v-bind:href="buildLink(props.item)">{{ $t("event.participants.list.lobby") }}</a>
            <v-btn class="mx-2" dark x-small icon raised color="primary" @click="copy(buildLink(props.item))">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.controls="props">
            <v-tooltip v-if="props.item.schedule && props.item.schedule.length && props.item.date" left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="mx-2"
                  color="primary"
                  dark
                  fab
                  raised
                  text
                  x-small
                  @click="editSchedule(props.item)"
                >
                  <v-icon dark>mdi-clock-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("event.participants.list.editSchedule") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <input id="link-copy" type="hidden" />
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import debounce from "../../../util/debounce";
const fileDownload = require("js-file-download");

export default {
  data() {
    return {
      valid: false,
      totalItems: 0,
      items: [],
      loading: true,
      search: "",
      pagination: {
        itemsPerPage: 25,
      },
      headers: [
        { text: this.$t("event.participants.list.name"), value: "fullName" },
        { text: this.$t("event.participants.list.email"), value: "email" },
        {
          text: this.$t("event.participants.list.link"),
          value: "accessToken",
          sortable: false,
        },
        {
          text: this.$t("event.participants.list.actions"),
          value: "controls",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      this.loading = true;
      const result = await this.$axios.get(`/event/${this.$route.params.eventId}/registered-participants`, {
        params: {
          page: page - 1,
          size: itemsPerPage,
          sortBy: sortBy.join(","),
          sortOrder: sortDesc.map((s) => (s ? "desc" : "asc")).join(","),
          search: this.search || undefined,
        },
      });
      this.items = result.rows;
      this.totalItems = result.count;
      this.loading = false;
    },

    async uploadParticipants() {
      const formData = new FormData();
      formData.append("file", this.$refs.uploadParticipants.files[0]);
      await this.$axios.post(`/event/${this.$route.params.eventId}/registered-participants`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      });
      this.$store.commit("SUCCESS", this.$t("event.participants.list.msgUploaded"));
      this.loadData();
    },

    async downloadParticipants() {
      this.$axios({
        url: `/event/${this.$route.params.eventId}/registered-participants/excelReport`,
        method: "GET",
        responseType: "blob",
        params: {
          root: window.location.origin,
        },
      }).then((response) => {
        fileDownload(
          response,
          `${this.$t("event.participants.list.exportFileName")}.xlsx`
        );
      });
    },
    async downloadExample() {
      this.$axios({
        url: `/event/${this.$route.params.eventId}/registered-participants/example`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        fileDownload(
          response,
          `${this.$t("event.participants.list.exampleFileName")}.csv`
        );
      });
    },
    copy(link) {
      let linkCopySource = document.querySelector("#link-copy");
      linkCopySource.setAttribute("value", link);
      linkCopySource.setAttribute("type", "text");
      linkCopySource.select();
      document.execCommand("selectAll");
      if (document.execCommand("copy")) {
        this.$store.commit("SUCCESS", this.$t("event.participants.list.copied"));
      }
      linkCopySource.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    buildLink(participant) {
      if(!this.$store.state.event) {
        return "";
      }
      return `${window.location.origin}/e/${this.$store.state.event.slug}?accessToken=${participant.accessToken}`;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    search: {
      handler() {
        debounce(this.loadData);
      },
      deep: true,
    },
  },
};
</script>
